import React, { useState } from 'react'
import {Modal } from 'antd';
import WebGoodsTypeDesc from './WebGoodsTypeDesc';
function WebGoodsTypeCheck(props) {
    const [open,setOpen] = useState(false)
    return (
        <>
            <a  onClick={() => {setOpen(true)}}>{props.text}</a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <WebGoodsTypeDesc
                    eowgt_id={props.eowgt_id}
                />             
            </Modal>
        </>
    )
}

export default WebGoodsTypeCheck